import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropertyCard from "../components/PropertyCard";
import "./HomePage.css";
import Testimonials from "../components/Testimonials";

export default function HomePage() {
  var navigate = useNavigate();
  var [checkin, setCheckin] = useState("");
  var [checkout, setCheckout] = useState("");
  var [guests, setGuests] = useState(1);
  var [properties, setProperties] = useState([]);

  const defaultDestinations = [
    { id: 1, city: "Tirana", tag: "Capital", description: "Colourful boulevards, cafe culture and modern energy", image: "./tirana.jpg" },
    { id: 2, city: "Pogradec", tag: "Lakeside", description: "Crystalline Lake Ohrid and mountain reflections", image: "./pogradec.jpg" },
    { id: 3, city: "Qerret", tag: "Coastal", description: "Adriatic sunsets and golden sand near Kavaje", image: "./qerret.jpg" },
  ];
  const saved = localStorage.getItem("adminDestinations");
  var destinations = saved ? JSON.parse(saved) : defaultDestinations;

  useEffect(function () {
    fetch("/api/properties?featured=true")
      .then(function (res) { return res.json(); })
      .then(function (data) { setProperties(data.properties || data || []); })
      .catch(function (err) { console.error("Failed to load properties", err); });
  }, []);

  function handleSearch(e) { e.preventDefault(); navigate("/stays"); }

  return (
    <div className="home">

      {/* HERO */}
      <section className="hero">
        <video className="hero-video" autoPlay muted loop playsInline preload="auto" src="/bookingalbvideo.mp4" />
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">Albania Awaits</span></div>
          <h1>Stay where Albania <em>shines</em></h1>
          <p className="hero-sub">Handpicked villas, boutique retreats and authentic experiences across the Albanian Riviera and beyond.</p>
          <form className="search-bar" onSubmit={handleSearch}>
            <div className="search-field"><label>Check In</label><input type="date" value={checkin} onChange={e => setCheckin(e.target.value)} /></div>
            <div className="search-sep" />
            <div className="search-field"><label>Check Out</label><input type="date" value={checkout} onChange={e => setCheckout(e.target.value)} /></div>
            <div className="search-sep" />
            <div className="search-field"><label>Guests</label><input type="number" min="1" max="20" value={guests} onChange={e => setGuests(e.target.value)} /></div>
            <button type="submit" className="search-btn">Search</button>
          </form>
        </div>
      </section>

      {/* FEATURED */}
      <section className="featured-section">
        <div className="container">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">Handpicked for You</span></div>
          <h2 className="section-title">Featured Properties</h2>
          <p className="section-subtitle">From beachfront villas to mountain retreats, we curate the finest stays across Albania.</p>
          <div className="properties-grid">
            {properties.map(function (p) { return <PropertyCard key={p._id} property={p} />; })}
          </div>
        </div>
      </section>

      {/* DESTINATIONS */}
      <section className="destinations-section">
        <div className="container">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">Explore Albania</span></div>
          <h2 className="section-title">Stay where Albania <em style={{ fontStyle: "italic", color: "#c8956c" }}>shines</em></h2>
          <p className="section-subtitle">From the capital energy to the lake stillness and the warmth of the Adriatic coast.</p>
          <div className="dest-track">
            {destinations.map(function (d, i) {
              return (
                <a key={d.id} className="dest-card" href={"/stays?city=" + encodeURIComponent(d.city)}>
                  <div className="dest-bg" style={{ backgroundImage: `url(${d.image})` }} />
                  <div className="dest-grad" />
                  <span className="dest-num">{String(i + 1).padStart(2, "0")} / {String(destinations.length).padStart(2, "0")}</span>
                  <span className="dest-tag">{d.tag}</span>
                  <div className="dest-info"><div className="dest-city">{d.city}</div><div className="dest-desc">{d.description}</div></div>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      {/* AUTOS SECTION */}
      <div className="autos-wrap">
        <div className="autos-card">
          <img className="autos-photo" src="/car-albania.jpg" alt="Albania Road" />
          <div className="g1"></div>
          <div className="g2"></div>
          <div className="g3"></div>
          <div className="g4"></div>
          <div className="br br-tl"></div>
          <div className="br br-tr"></div>
          <div className="br br-bl"></div>
          <div className="br br-br"></div>
          <div className="side-label">bookingalb.com · car rental albania</div>
          <div className="card-chrome-top">
            <div className="chrome-left">
              <div className="chrome-dot"></div>
              <span className="chrome-label">Car Rental</span>
              <div className="chrome-divider"></div>
              <span className="chrome-sub">Albania Fleet 2025</span>
            </div>
            <div className="chrome-right">
              <div className="chrome-pill">
                <div className="chrome-pill-dot"></div>
                Available Now
              </div>
            </div>
          </div>
          <div className="card-content">
            <div className="content-left">
              <div className="cl-eyebrow">
                <span className="cl-eyebrow-num">01</span>
                <div className="cl-eyebrow-line"></div>
                <span className="cl-eyebrow-tag">Explore Albania</span>
              </div>
              <h2 className="cl-title">Freedom to roam every</h2>
              <span className="cl-title-em">Albanian road</span>
              <p className="cl-desc">From the sun-drenched Riviera to the wild northern highlands — Albania is best discovered on your own terms. Hand-picked vehicles, no hidden fees, just open roads.</p>
              <div className="cl-cta">
                <button className="btn-A" onClick={() => navigate("/autos")}>
                  <span>Browse Our Fleet</span>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </button>
              </div>
            </div>
            <div className="content-right">
              <div className="stats-panel">
                <div className="sp-item">
                  <div className="sp-num">4<sup>+</sup></div>
                  <div className="sp-label">Categories</div>
                </div>
                <div className="sp-item">
                  <div className="sp-num">24<sup>h</sup></div>
                  <div className="sp-label">Support</div>
                </div>
                <div className="sp-item">
                  <div className="sp-num">0<sup>%</sup></div>
                  <div className="sp-label">Hidden fees</div>
                </div>
              </div>
              <div className="cats-panel">
                <div className="cats-title">Vehicle types</div>
                <div className="cats-grid">
                  <div className="cat-item"><span className="cat-icon">⚡</span>Economic</div>
                  <div className="cat-item"><span className="cat-icon">🚗</span>Sedan</div>
                  <div className="cat-item"><span className="cat-icon">🏔️</span>4×4 SUV</div>
                  <div className="cat-item"><span className="cat-icon">🚐</span>Van</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Testimonials />

      {/* OWNERS SECTION */}
      <div className="owners-wrap">
        <div className="owners-card">
          <div className="ow-bg-left" />
          <div className="ow-bg-right" />
          <div className="ow-noise" />

          {/* corner brackets — same as autos */}
          <div className="br br-tl"></div>
          <div className="br br-tr"></div>
          <div className="br br-bl"></div>
          <div className="br br-br"></div>
          <div className="ow-side-label">bookingalb.com · property management albania</div>

          {/* chrome top bar — same pattern as autos */}
          <div className="ow-chrome-top">
            <div className="chrome-left">
              <div className="chrome-dot"></div>
              <span className="chrome-label">For Owners</span>
              <div className="chrome-divider"></div>
              <span className="chrome-sub">Property Management · Albania</span>
            </div>
            <div className="chrome-right">
              <div className="chrome-pill">
                <div className="chrome-pill-dot"></div>
                Now Accepting Properties
              </div>
            </div>
          </div>

          {/* main grid */}
          <div className="ow-body">

            {/* LEFT — pitch */}
            <div className="ow-left">
              <div className="cl-eyebrow">
                <span className="cl-eyebrow-num">02</span>
                <div className="cl-eyebrow-line"></div>
                <span className="cl-eyebrow-tag">Own a property in Albania?</span>
              </div>

              <h2 className="ow-headline">Your property.<br />Our <em>expertise.</em><br />Their stay.</h2>

              <p className="ow-sub">We handle everything — from professional photography and listings to guest communication and check-ins. You collect the earnings, we do the work.</p>

              <div className="ow-stats">
                <div className="ow-stat">
                  <span className="ow-stat-num">€2.4k</span>
                  <span className="ow-stat-label">avg. peak month</span>
                </div>
                <div className="ow-stat">
                  <span className="ow-stat-num">90%</span>
                  <span className="ow-stat-label">summer occupancy</span>
                </div>
                <div className="ow-stat">
                  <span className="ow-stat-num">10%</span>
                  <span className="ow-stat-label">our fee only</span>
                </div>
              </div>

              <div className="ow-features">
                <div className="ow-feature">
                  <div className="ow-feature-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c8956c" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M20.188 10.934c.23.605.312 1.17.312 1.766 0 3.866-3.582 7-8 7s-8-3.134-8-7 3.582-7 8-7c1.33 0 2.608.32 3.727.876M22 6l-6 6"/></svg>
                  </div>
                  <div className="ow-feature-text">
                    <strong>Professional photography</strong>
                    We shoot and style your property at no extra cost.
                  </div>
                </div>
                <div className="ow-feature">
                  <div className="ow-feature-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c8956c" strokeWidth="1.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                  </div>
                  <div className="ow-feature-text">
                    <strong>24/7 guest communication</strong>
                    We handle every message, review, and issue.
                  </div>
                </div>
                <div className="ow-feature">
                  <div className="ow-feature-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c8956c" strokeWidth="1.5"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
                  </div>
                  <div className="ow-feature-text">
                    <strong>Dynamic pricing</strong>
                    Peak and off-season rates optimized every week.
                  </div>
                </div>
              </div>

              <div className="ow-cta">
                <button className="btn-A" onClick={() => navigate("/for-owners")}>
                  <span>For Owners</span>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </button>
              </div>
            </div>

            {/* RIGHT — visual panels */}
            <div className="ow-right">

              {/* properties photo card */}
              <div className="ow-props-card">
                <img src="/uploads/properties.jpg" alt="Our properties" className="ow-props-img" />
                <div className="ow-props-fade" />
              </div>

              {/* property type grid */}
              <div className="ow-types">
                <div className="ow-types-label">We manage</div>
                <div className="ow-types-grid">
                  <div className="ow-type-item">
                    <span className="ow-type-icon">🏖️</span>
                    <span>Seaside villas</span>
                  </div>
                  <div className="ow-type-item">
                    <span className="ow-type-icon">🏢</span>
                    <span>City apartments</span>
                  </div>
                  <div className="ow-type-item">
                    <span className="ow-type-icon">🏡</span>
                    <span>Rural homes</span>
                  </div>
                  <div className="ow-type-item">
                    <span className="ow-type-icon">⛰️</span>
                    <span>Mountain lodges</span>
                  </div>
                </div>
              </div>

              {/* city rates strip */}
              <div className="ow-cities">
                <div className="ow-cities-label">Peak monthly gross · selected cities</div>
                <div className="ow-cities-list">
                  <div className="ow-city-item">
                    <span className="ow-city-name">Ksamil</span>
                    <div className="ow-city-bar-wrap"><div className="ow-city-bar" style={{ width: "100%" }}></div></div>
                    <span className="ow-city-val">€2,400</span>
                  </div>
                  <div className="ow-city-item">
                    <span className="ow-city-name">Saranda</span>
                    <div className="ow-city-bar-wrap"><div className="ow-city-bar" style={{ width: "87%" }}></div></div>
                    <span className="ow-city-val">€2,100</span>
                  </div>
                  <div className="ow-city-item">
                    <span className="ow-city-name">Dhërmiu</span>
                    <div className="ow-city-bar-wrap"><div className="ow-city-bar" style={{ width: "92%" }}></div></div>
                    <span className="ow-city-val">€2,200</span>
                  </div>
                  <div className="ow-city-item">
                    <span className="ow-city-name">Tirana</span>
                    <div className="ow-city-bar-wrap"><div className="ow-city-bar" style={{ width: "46%" }}></div></div>
                    <span className="ow-city-val">€1,100</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      {/* WHY */}
      <section className="why-section">
        <div className="container">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">Why BookingAlb</span></div>
          <h2 className="section-title">Albania deserves to be <em style={{ fontStyle: "italic", color: "#c8956c" }}>discovered</em></h2>
          <div className="why-grid">
            <div className="why-card"><div className="why-num">01</div><h3>Handpicked Stays</h3><p>Every property is personally vetted for quality, comfort and authentic Albanian character.</p></div>
            <div className="why-card"><div className="why-num">02</div><h3>Best Price Guarantee</h3><p>Book directly with us and always get the best available rate with no hidden fees.</p></div>
            <div className="why-card"><div className="why-num">03</div><h3>Local Expertise</h3><p>Our team is Albanian. We know every hidden gem and every secret beach.</p></div>
            <div className="why-card"><div className="why-num">04</div><h3>24/7 Support</h3><p>Need help before, during or after your stay? We are always just a message away.</p></div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container cta-inner">
          <div className="eyebrow" style={{ justifyContent: "center" }}><div className="eline"></div><span className="etxt">Start Exploring</span><div className="eline"></div></div>
          <h2>Ready to discover Albania?</h2>
          <p>Join thousands of travellers who have discovered the magic of Albania with BookingAlb.</p>
          <button className="btn-primary" onClick={() => navigate("/stays")}>Browse All Properties</button>
        </div>
      </section>

    </div>
  );
}